module.exports = __webpack_public_path__ + "img/rg.cd341648.png";